export function checkForOneLevelSSCC(data: any): any {
  let flag = 0

  if (data && Array.isArray(data) && data.length > 0) {
    const epcisListdata = data[0]?.parsedJsonDto
    if (Array.isArray(epcisListdata) && epcisListdata.length > 0) {
      epcisListdata.forEach((item: any) => {
        if (item.subChild && Array.isArray(item.subChild) && item.subChild.length > 0) {
          flag = 1
        }
      })
    }

    return flag === 1 ? false : true
  }
  return data && flag === 1 ? false : true
}
